import React, { useEffect } from "react";
import "../assets/css/VisionMission.css";
import visionImg from "../assets/images/vission.jpg";
import missionImg from "../assets/images/mission.jpg";

const VisionMission = () => {
  useEffect(() => {
    const elements = document.querySelectorAll("[data-animate]");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("animate");
        });
      },
      { threshold: 0.25 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => elements.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <>
      {/* ---------- VISION SECTION ---------- */}
      <section className="vm-section">
        <div className="container">
          <div className="row align-items-center">
            {/* TEXT LEFT */}
            <div className="col-md-6 vm-text" data-animate="slide-left">
              <p className="vm-label">VISION</p>
              <h2 className="vm-title">Reimagining the Future of Healthcare</h2>
              <p className="vm-desc">
                To revolutionize the healthcare sector by integrating advanced
                science with compassionate care — empowering healthier lives
                worldwide. Our aim is to build a legacy of innovation,
                reliability, and ethical responsibility.
              </p>
            </div>

            {/* IMAGE RIGHT */}
            <div className="col-md-6 text-center" data-animate="slide-right">
              <img src={visionImg} alt="Our Vision" className="vm-image" />
            </div>
          </div>
        </div>

        {/* Decorative floating dots */}
        <span className="decor decor-1"></span>
        <span className="decor decor-2"></span>
      </section>

      {/* ---------- MISSION SECTION ---------- */}
      <section className="vm-section">
        <div className="container">
          <div className="row align-items-center flex-md-row-reverse">
            {/* TEXT RIGHT */}
            <div className="col-md-6 vm-text" data-animate="slide-right">
              <p className="vm-label">MISSION</p>
              <h2 className="vm-title">Delivering Quality with Purpose</h2>
              <p className="vm-desc">
                To continuously innovate and deliver top-tier biopharmaceutical
                solutions, ensuring accessibility, quality, and care in every
                product. We believe in nurturing trust and transforming
                well-being across the globe.
              </p>
            </div>

            {/* IMAGE LEFT */}
            <div className="col-md-6 text-center" data-animate="slide-left">
              <img src={missionImg} alt="Our Mission" className="vm-image" />
            </div>
          </div>
        </div>

        {/* Decorative floating dots */}
        <span className="decor decor-3"></span>
        <span className="decor decor-4"></span>
      </section>
    </>
  );
};

export default VisionMission;
